import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import SvgColor from 'src/components/svg-color';
import { useAuthContext } from 'src/auth/hooks';
import Iconify  from 'src/components/iconify/index';

// ----------------------------------------------------------------------

const iconCustom = (name) => (
  <Iconify  icon= {name} />
);

// ----------------------------------------------------------------------

export function useNavData() {
  const { user: dataUser } = useAuthContext();
  let dataFilteredWithPermission = [];

  const data = useMemo(
    () => [
      {
        subheader: 'Configuracion',
        items: [
          { title: 'Usuarios', path: paths.dashboard.configuration.user.list, icon: iconCustom("mdi:users"), componente: 'Users', },
          { title: 'Roles', path: paths.dashboard.configuration.roles.list, icon: iconCustom("eos-icons:role-binding"), componente: 'Roles', },
          { title: 'Relación servicio - rol', path: paths.dashboard.configuration.relationRolService.list, icon: iconCustom("mdi:relation-many-to-only-one"), componente: 'ServicioRol', },
          { title: 'Sucursales', path: paths.dashboard.configuration.branches.list, icon: iconCustom("material-symbols:store"), componente: 'Sucursales', },
          { title: 'Empresas', path: paths.dashboard.configuration.companies.list, icon: iconCustom("ion:business"), componente: 'Empresas', },          
          { title: 'Dispositivos', path: paths.dashboard.configuration.device.list, icon: iconCustom("ix:photo-camera-add"), componente: 'Dispositivos', },
          { title: 'Publicidad', path: paths.dashboard.configuration.advertising.list, icon: iconCustom("pepicons-pop:megaphone-circle-filled"), componente: 'Publicidad', },

        ],
      },
      {
        subheader: 'Dashboards',
        items: [
          { title: 'Análisis general', path: paths.dashboard.dashboards.smartSensing.list, icon: iconCustom("material-symbols-light:speed-camera-rounded"), componente: 'SmartSensing', },
          { title: 'Análisis visitantes', path: paths.dashboard.dashboards.visitantes.list, icon: iconCustom("mdi:face-recognition"), componente: 'AnalisisVisitantes', },
          { title: 'Análisis visitas', path: paths.dashboard.dashboards.visitas.list, icon: iconCustom("mdi:human-male-height"), componente: 'AnalisisVisitas', },
          { title: 'Mapa de calor', path: paths.dashboard.dashboards.mapaCalor.list, icon: iconCustom("mdi:map-marker-radius"), componente: 'MapaCalor', },
        ],
      },
      {
        subheader: 'Proceso',
        items: [
          { title: 'Scheduler Reportes IA', path: paths.dashboard.process.scheduler, icon: iconCustom("mdi:robot-industrial"), componente: 'SchedulerReportes', },
          { title: 'Monitoreo Sensores', path: paths.dashboard.process.sensorsMonitor, icon: iconCustom("mdi:heart-pulse"), componente: 'MonitoreoSensores', },
        ],
      },
    ],
    []
  );

  if(dataUser) {
    const componentsAccessUser = dataUser?.routes?.map(ruta => {
      let components = [];
      if(ruta.subMenu) {
        components = ruta.subMenu.map((component) => (component.componente.toLowerCase()))
      }
      else {
        components = ruta.componente.toLowerCase();
      }
      return components;
    }).flat();
    
    dataFilteredWithPermission = data.map((item) => {
      let itemsFilteres = {};
      if(item.items.length > 0) {
        itemsFilteres = item.items.filter((servicio) => (componentsAccessUser.includes(servicio.componente.toLowerCase())) );
      }
      return {
        items: itemsFilteres,
        subheader:  item.subheader,
      }
    });
    
    dataFilteredWithPermission = dataFilteredWithPermission.filter((array) => (array.items.length>0));
    
  }

  return dataFilteredWithPermission || data;
}
